import React from "react";
import { useNavigate } from "react-router-dom";
import "../App.css"; 
import Logo from "../Rijschool.png";

const Homepage = () => {
  const navigate = useNavigate();

  const handleLoginButtonClick = () => {
    console.log("Student button clicked");
    navigate("/form");
  };

  const handleAdminLoginButtonClick = () => {
    console.log("Inloggen als rijinstructeur button clicked");
    navigate("/admin/login");
  };

  const handleAboutUsButtonClick = () => {
    navigate("/about");
  };

  const handlePricingButtonClick = () => {
    navigate("/pricing");
  };

  return (
    <div className="main-content-wrapper fade-in-up">
      <h1 className="aharoni-style homepage-header" style={{ fontSize: '3.5em', marginBottom: '40px' }}>PlanSucces</h1>
      
      <div className="admin-grid" style={{ maxWidth: '800px' }}>
        <div className="admin-card">
          <h3>Rijinstructeur</h3>
          <p>Beheer je afspraken, vragenlijsten en leerlingen in het dashboard.</p>
          <button className="btn" onClick={handleAdminLoginButtonClick} style={{ width: '100%', minWidth: 'auto' }}>
            Inloggen
          </button>
        </div>

        <div className="admin-card">
          <h3>Student</h3>
          <p>Plan je lessen in, bekijk je voortgang en geef feedback.</p>
          <button className="btn" onClick={handleLoginButtonClick} style={{ width: '100%', minWidth: 'auto' }}>
            Ga door
          </button>
        </div>
      </div>

      {/* Bottom navigation buttons */}
      <div className="homepage-footer">
        <button 
          className="action-button-blue" 
          onClick={handleAboutUsButtonClick}
          style={{ minWidth: '120px' }}
        >
          Over ons
        </button>
        <button 
          className="action-button-blue" 
          onClick={handlePricingButtonClick}
          style={{ minWidth: '120px' }}
        >
          Prijzen
        </button>
      </div>
    </div>
  );
};

export default Homepage;
